<template>
  <div class="card mb-2">
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <div>
          {{ transaction.created_at }}
        </div>
        <div class="points text-primary">
          {{ transaction.points > 0 ? '+'+transaction.points : transaction.points }} Points
        </div>
      </div>
      <div>
        {{ transaction.transaction_description }}
        <span v-if="transaction.order && source != 'Admin'">{{ transaction.order.source === "eBay" ? "#LE" : "#L" }}{{ transaction.order.serial_number }}</span>
        <a v-else-if="transaction.order && source == 'Admin'" target="_blank" :href="orderUrl(transaction.order.serial_number )" >{{ transaction.order.source === "eBay" ? "#LE" : "#L" }}{{ transaction.order.serial_number }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Transaction",
  props: ['transaction', 'source'],
  methods: {
    orderUrl(id) {
      return '/admin/orders/' + id
    },
  },
  computed : {
    userLabel() {
      if(this.source == 'Admin') {
        return ""
      } else {
        return 'YOUR REWARDS'
      }
    }
  }
}
</script>

<style scoped>
  .points {
    //color: #00B9E8;
    font-size: 20px;
    font-weight: bold;
  }
</style>
